import React, {Component} from 'react'
import ReGenerateBatch from './ReGenerateBatch'
import ReGenerateItems from './ReGenerateItems'
import {Divider, Icon} from 'antd'
import './../styles/_index.scss'
import {Link} from "react-router-dom"

class ReGenerateContainer extends Component {

    render() {
        return (
            <div className="UpdateBatchesContainer p-5">
                <div className='row'>
                    <div className='col-12 mx-auto'>
                        <div className="HeadReGen mb-3 d-flex justify-content-end align-items-center">
                            <Link to={'/jobs-generated'} className='ant-btn ant-btn-lg ant-btn-primary ml-3'>
                                <Icon type="ordered-list" className='mr-2'/>Danh sách generate lại file in
                            </Link>
                        </div>
                        <ReGenerateBatch/>
                        <Divider>Hoặc</Divider>
                        <ReGenerateItems/>
                    </div>
                </div>
            </div>
        )
    }

}

export default ReGenerateContainer